import { render, staticRenderFns } from "./LogoCarpardooSvg.vue?vue&type=template&id=498add16"
import script from "./LogoCarpardooSvg.vue?vue&type=script&lang=js"
export * from "./LogoCarpardooSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports